export enum EnumAbmBuscadorFlow {
  Mantenedor = 'MANTENEDOR',
  Edicion = 'Edición',
  Configuracion = 'Configuración Sub Dominio',
  VistaPrevia = 'Vista Previa de',
  Eliminacion = 'DELETE',
  Buscador = 'Buscador '
}
